import React from 'react';

export default function ApiClientsListItem(props) {
    const show = () => {
        window.location.href = props.item.showUrl;
    };

    return (
        <div className="table__card">
            <h5 className="tw-cursor-pointer" onClick={show}>
                {props.item.name}
            </h5>
        </div>
    );
}
